export default {
  mounted() {
    setTimeout(() => {
      const $ = window.jQuery;
      $(document).ready(() => {
        $(".change-language").on("change", function changeLanguageF() {
          const selectedLanguage = $(this).val();
          if (!selectedLanguage) return;
          const currentURL = new URL(window.location.href);
          const availableLocales = window.appConfig.availableLocales;
          const urlLanguage = availableLocales.find((locale) =>
            currentURL.pathname.startsWith(`/${locale}`)
          );
          const newPathname = urlLanguage
            ? currentURL.pathname.replace(urlLanguage, selectedLanguage)
            : selectedLanguage + currentURL.pathname;
          const newURL = new URL(window.location.href);
          newURL.pathname = newPathname;
          window.location = newURL.href;
        });
      });
    }, 1500);
  },
};
